// import { RenderCellTypes } from "types/RenderCellTypes";
// import { metricTypeEnum } from "app/pages/SalesDemoPage/data/type";

import { metricTypeEnum } from "app/pages/SalesPortalPage/LayoutV1/data/type";
import { RenderCellTypes } from "./RenderCellTypes";
import { GridSortModel } from "@mui/x-data-grid";

// type apiDetailsType = {
//   endpoint: string;
//   pathParams?: any;
//   queryParams?: any;
// };

// type renderCellMapperType = {
//   field: string;
//   renderCell: string;
// }

// class DataGridTypes {
//   apiDetails: apiDetailsType;
//   pageSize: number;
//   pageMode: string;
//   filterable: boolean;
//   rendermode: string;
//   editable: boolean;
//   exportable: boolean;
//   gridHeight: number;
//   exportFileName: string;
//   columnResizable: boolean;
//   isRowSelectable: boolean;
//   isOpportunity: boolean;
//   multiSelectable?: boolean;
//   renderCellMapping?: Array<renderCellMapperType>;
//   visibleColumns?: Array<string>;


//   constructor(
//     apiDetails: apiDetailsType,
//     pageSize: number,
//     pageMode: string,
//     filterable: boolean,
//     rendermode: string,
//     editable: boolean,
//     exportable: boolean,
//     gridHeight: number,
//     exportFileName: string,
//     columnResizable: boolean,
//     isRowSelectable: boolean,
//     isOpportunity: boolean,
//     multiSelectable?: boolean,
//     renderCellMapping?: Array<renderCellMapperType>,
//     visibleColumns?: Array<string>,
//   ) {
//     this.apiDetails = apiDetails;
//     this.pageSize = pageSize;
//     this.pageMode = pageMode;
//     this.filterable = filterable;
//     this.rendermode = rendermode;
//     this.editable = editable;
//     this.exportable = exportable;
//     this.gridHeight = gridHeight;
//     this.exportFileName = exportFileName;
//     this.columnResizable = columnResizable;
//     this.isRowSelectable = isRowSelectable;
//     this.isOpportunity = isOpportunity;
//     this.multiSelectable = multiSelectable;
//     this.renderCellMapping = renderCellMapping;
//     this.visibleColumns = visibleColumns || [];
//   }

//   static API_VERSION_1: string = 'api/v1';
//   static API_VERSION_2: string = 'api/v2';

//   static UPLOAD_DATA_DETAILS = (upload_id: string, selectedDealer: any, uploadSummary: any) =>
//     new DataGridTypes(
//       {
//         endpoint: `${DataGridTypes.API_VERSION_2}/data-feed/details`,
//         pathParams: { id: upload_id },
//         queryParams: { dealer: selectedDealer.dealer },
//       },
//       30,
//       "scroll",
//       true,
//       "server",
//       true,
//       true,
//       700,
//       `${selectedDealer?.site_title?.split(" ").join("_")}`,
//       true,
//       true,
//       true,
//       false,
//       [
//         {
//           field: 'name',
//           renderCell: RenderCellTypes.BUTTON,
//         },
//         {
//           field: 'lead_created_date_crm',
//           renderCell: RenderCellTypes.DATE,
//         },
//       ],
//     );
//   static USERS_DATA = () =>
//     new DataGridTypes(
//       {
//         endpoint: `${DataGridTypes.API_VERSION_2}/users/datagrid`,
//       },
//       0,
//       "scroll",
//       true,
//       "client",
//       false,
//       false,
//       500,
//       `-`,
//       true,
//       true,
//       true,
//       false,
//       [
//         {
//           field: 'name',
//           renderCell: RenderCellTypes.BUTTON,
//         },
//         {
//           field: 'status',
//           renderCell: RenderCellTypes.STATUS,
//         },
//       ],
//       ["first_name", "name", "last_name", "email", "zip", "status"]
//     );
//   static DEALERS_DATA = () =>
//     new DataGridTypes(
//       {
//         endpoint: `${DataGridTypes.API_VERSION_2}/dealers/datagrid`,
//       },
//       20,
//       "scroll",
//       true,
//       "server",
//       false,
//       true,
//       700,
//       `all_dealership_grid`,
//       true,
//       true,
//       true,
//       false,
//       [
//         {
//           field: 'name',
//           renderCell: RenderCellTypes.BUTTON,
//         },
//         {
//           field: 'status',
//           renderCell: RenderCellTypes.STATUS,
//         },
//         {
//           field: 'segments_no',
//           renderCell: RenderCellTypes.POPOVER_INFO,
//         },
//         {
//           field: 'prospects',
//           renderCell: RenderCellTypes.POPOVER_INFO,
//         },
//         {
//           field: 'prospects_in_nurturing',
//           renderCell: RenderCellTypes.POPOVER_INFO,
//         },
//       ],
//       ['name', 'dealer_group', 'manufacturers', 'segments_no', 'prospects', 'prospects_in_nurturing', 'status']
//     );
//   static DEALERS_GROUP_DATA = () =>
//     new DataGridTypes(
//       {
//         endpoint: `${DataGridTypes.API_VERSION_2}/dealer-groups/datagrid`,
//       },
//       20,
//       "scroll",
//       false,
//       "server",
//       false,
//       false,
//       500,
//       `-`,
//       true,
//       true,
//       true,
//       false,
//       [
//         {
//           field: 'name',
//           renderCell: RenderCellTypes.BUTTON,
//         },
//       ],
//       ["name", "makes", "manufacturer", "type"]
//     );
//   static SEGMENTS = (dealerId) =>
//     new DataGridTypes(
//       {
//         endpoint: `${DataGridTypes.API_VERSION_2}/segments`,
//         queryParams: { dealer: dealerId },
//       },
//       20,
//       "scroll",
//       false,
//       "server",
//       false,
//       true,
//       800,
//       `segments-export`,
//       true,
//       true,
//       true,
//       true,
//       [
//         {
//           field: 'name',
//           renderCell: RenderCellTypes.BUTTON_WITH_ICON,
//         },
//         {
//           field: 'no_of_leads',
//           renderCell: RenderCellTypes.COUNT_WITH_ICON,
//         },
//         {
//           field: 'LEAD_CONTACTED',
//           renderCell: RenderCellTypes.NUMBER,
//         },
//         {
//           field: 'status',
//           renderCell: RenderCellTypes.STATUS,
//         },
//         {
//           field: 'last_added_date',
//           renderCell: RenderCellTypes.DATE,
//         },
//         {
//           field: 'created_at',
//           renderCell: RenderCellTypes.DATE,
//         },
//         {
//           field: 'updated_at',
//           renderCell: RenderCellTypes.DATE,
//         },
//       ],
//       ["name", "no_of_leads", "LEAD_CONTACTED", "status", "last_added_date", "leads_in_nurturing", "created_at", "updated_at"]
//     );

//   static SALES_DEMO = (renderData: any, mySqlFlag: Boolean, filterType: string, timeperiod: string | number) => {
//     let endpoint = `${DataGridTypes.API_VERSION_2}`;
//     if (
//       filterType === metricTypeEnum.opportunityAddedInNurturing ||
//       filterType === metricTypeEnum.leadContacted ||
//       filterType === metricTypeEnum.leadSold
//     )
//       endpoint += '/leads';
//     else
//       endpoint += '/segments';
//     const queryParams = {
//       group_entity_filter: JSON.stringify(renderData.data?.group_entity_filter) || {},
//       dealer: renderData.dealershipId,
//       mysql: mySqlFlag,
//       timeperiod: timeperiod,
//       lead_filter: JSON.stringify(renderData.data?.lead_filter),
//     };

//     const now = new Date();
//     const formattedDate = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

//     return new DataGridTypes(
//       {
//         endpoint,
//         queryParams,
//       },
//       20,
//       "scroll",
//       false,
//       "server",
//       false,
//       true,
//       700,
//       `${filterType}_${timeperiod}_${formattedDate}`.toLowerCase(),
//       true,
//       true,
//       true,
//       false,
//       [
//         {
//           field: 'name',
//           renderCell: RenderCellTypes.BUTTON
//         },
//         {
//           field: 'LEAD_CONTACTED',
//           renderCell: RenderCellTypes.COUNT_WITH_ICON
//         },
//       ]
//     );
//   }
// }

// export default DataGridTypes;

// enums for commonly used string values
export enum PageMode {
  Scroll = "scroll",
  // add more page modes if needed
}

export enum RenderMode {
  Server = "server",
  Client = "client",
}

// existing types
type ApiDetailsType = {
  endpoint: string;
  pathParams?: any;
  queryParams?: any;
};

type RenderCellMapperType = {
  field: string;
  renderCell: string;
};

// options interface for DataGridTypes
interface DataGridOptions {
  apiDetails: ApiDetailsType;
  pageSize?: number;
  pageMode?: PageMode;
  filterable?: boolean;
  renderMode?: RenderMode;
  editable?: boolean;
  exportable?: boolean;
  gridHeight?: number;
  exportFileName?: string;
  columnResizable?: boolean;
  isRowSelectable?: boolean;
  isOpportunity?: boolean;
  multiSelectable?: boolean;
  renderCellMapping?: RenderCellMapperType[];
  visibleColumns?: string[];
  columnSortModel?: GridSortModel;
  filterableFields?: string[];
}

class DataGridTypes {
  apiDetails: ApiDetailsType;
  pageSize: number;
  pageMode: PageMode;
  filterable: boolean;
  renderMode: RenderMode;
  editable: boolean;
  exportable: boolean;
  gridHeight: number;
  exportFileName: string;
  columnResizable: boolean;
  isRowSelectable: boolean;
  isOpportunity: boolean;
  multiSelectable?: boolean;
  renderCellMapping?: RenderCellMapperType[];
  visibleColumns?: string[];
  columnSortModel?: GridSortModel;
  filterableFields?: string[];

  // the constructor now accepts a single options object
  constructor(options: DataGridOptions) {
    // assign with defaults
    this.apiDetails = options.apiDetails;
    this.pageSize = options.pageSize ?? 0;
    this.pageMode = options.pageMode ?? PageMode.Scroll;
    this.filterable = options.filterable ?? false;
    this.renderMode = options.renderMode ?? RenderMode.Server;
    this.editable = options.editable ?? false;
    this.exportable = options.exportable ?? false;
    this.gridHeight = options.gridHeight ?? 500;
    this.exportFileName = options.exportFileName ?? "-";
    this.columnResizable = options.columnResizable ?? true;
    this.isRowSelectable = options.isRowSelectable ?? false;
    this.isOpportunity = options.isOpportunity ?? false;
    this.multiSelectable = options.multiSelectable;
    this.renderCellMapping = options.renderCellMapping;
    this.visibleColumns = options.visibleColumns || [];
    this.columnSortModel = options.columnSortModel || [];
    this.filterableFields = options.filterableFields || [];
  }

  // static API version constants
  static API_VERSION_1: string = 'api/v1';
  static API_VERSION_2: string = 'api/v2';

  // static methods returning pre-configured grid types remain usable as before
  static UPLOAD_DATA_DETAILS = (uploadId: string, selectedDealer: any, uploadSummary: any) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/data-feed/details`,
        pathParams: { id: uploadId },
        queryParams: { dealer: selectedDealer.dealer },
      },
      pageSize: 30,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: true,
      exportable: true,
      gridHeight: 700,
      exportFileName: selectedDealer?.site_title?.split(" ").join("_"),
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        {
          field: 'name',
          renderCell: RenderCellTypes.BUTTON,
        },
        {
          field: 'lead_created_date_crm',
          renderCell: RenderCellTypes.DATE,
        },
      ],
    });

  static USERS_DATA = () => {
    const now = new Date();
    const formattedDate = `${now.getFullYear()}${(now.getMonth() + 1)
      .toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours()
        .toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds()
          .toString().padStart(2, '0')}`;

    return new DataGridTypes({
      apiDetails: { endpoint: `${DataGridTypes.API_VERSION_2}/users/datagrid?audit_meta.created_user_type=USER` },
      pageSize: 0,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Client,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: `users_export_${formattedDate}`,
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        {
          field: 'name',
          renderCell: RenderCellTypes.BUTTON,
        },
        {
          field: 'status',
          renderCell: RenderCellTypes.STATUS,
        },
        {
          field: 'created_at',
          renderCell: RenderCellTypes.DATE,
        },
      ],
      visibleColumns: ["name", "email", "created_at", "status" ],
      filterableFields: ["name", "email", "status"],
    });
  }

  static CAMPAIGNS = (parentGroup: string, dealerId: string) => {
    return new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/campaigns`,
        queryParams: { dealer: dealerId, parent_group: parentGroup },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 700,
      exportFileName: "campaigns_export",
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: true,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON_WITH_ACTION_ICONS },
        { field: 'no_of_leads', renderCell: RenderCellTypes.COUNT_WITH_ICON },
        { field: 'leads_in_nurturing', renderCell: RenderCellTypes.COUNT_WITH_ICON },
        { field: 'status', renderCell: RenderCellTypes.STATUS },
        { field: 'type', renderCell: RenderCellTypes.TEXT },
        { field: 'last_email_sent_date', renderCell: RenderCellTypes.DATE },
        { field: 'last_added_date', renderCell: RenderCellTypes.DATE },
      ],
      columnSortModel: [
        { field: 'name', sort: 'asc' },
      ],
      visibleColumns: ['name', 'no_of_leads', 'leads_in_nurturing', 'status', 'type', 'last_email_sent_date', 'last_added_date'],
      filterableFields: ['name', 'no_of_leads', 'leads_in_nurturing', 'status', 'type', 'last_email_sent_date', 'last_added_date'],
    });
  }
  static DEALERS_DATA = () =>
    new DataGridTypes({
      apiDetails: { endpoint: `${DataGridTypes.API_VERSION_2}/dealers/datagrid` },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 660,
      exportFileName: "all_dealership_grid",
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON },
        { field: 'status', renderCell: RenderCellTypes.STATUS },
        { field: 'segments_no', renderCell: RenderCellTypes.POPOVER_INFO },
        { field: 'prospects', renderCell: RenderCellTypes.POPOVER_INFO },
        { field: 'prospects_in_nurturing', renderCell: RenderCellTypes.POPOVER_INFO },
      ],
      columnSortModel: [
        { field: 'name', sort: 'asc' },
      ],
      visibleColumns: ['name', 'dealer_group', 'manufacturers', 'segments_no', 'prospects', 'prospects_in_nurturing', 'status'],
      filterableFields: ['name', 'dealer_group', 'manufacturers', 'segments_no', 'prospects', 'prospects_in_nurturing', 'status'],
    });
  static DEALERS_MANAGEMENT = () =>
    new DataGridTypes({
      apiDetails: { endpoint: `${DataGridTypes.API_VERSION_2}/dealers/datagrid` },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 700,
      exportFileName: "all_dealership_grid",
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        // { field: 'name', renderCell: RenderCellTypes.BUTTON },
        { field: 'status', renderCell: RenderCellTypes.STATUS },
        { field: 'segments_no', renderCell: RenderCellTypes.POPOVER_INFO },
        { field: 'prospects', renderCell: RenderCellTypes.POPOVER_INFO },
        { field: 'prospects_in_nurturing', renderCell: RenderCellTypes.POPOVER_INFO },
      ],
      columnSortModel: [
        { field: 'name', sort: 'asc' },
      ],
      visibleColumns: ['name', 'dealer_group', 'manufacturers', 'segments_no', 'prospects', 'prospects_in_nurturing', 'status'],
      filterableFields: ['name', 'dealer_group', 'manufacturers', 'segments_no', 'prospects', 'prospects_in_nurturing', 'status'],
    });

  static DEALERS_GROUP_DATA = () =>
    new DataGridTypes({
      apiDetails: { endpoint: `${DataGridTypes.API_VERSION_2}/dealer-groups/datagrid?audit_meta.created_user_type=USER` },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: "dealer_groups_export",
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON },
      ],
      visibleColumns: ["name", "makes", "manufacturer", "type"],
      filterableFields: ["name", "makes", "manufacturer", "type"],
    });

  // static ROLES_DATA = () =>
  //   new DataGridTypes({
  //     apiDetails: { endpoint: `${DataGridTypes.API_VERSION_2}/roles` },
  //     pageSize: 0,
  //     pageMode: PageMode.Scroll,
  //     filterable: true,
  //     renderMode: RenderMode.Server,
  //     editable: false,
  //     exportable: true,
  //     gridHeight: 500,
  //     exportFileName: "roles-export",
  //     columnResizable: true,
  //     isRowSelectable: true,
  //     isOpportunity: false,
  //     multiSelectable: false,
  //     renderCellMapping: [
  //       { field: 'name', renderCell: RenderCellTypes.BUTTON },
  //       { field: 'status', renderCell: RenderCellTypes.STATUS }
  //     ],
  //     visibleColumns: ["name", "description", "permissions", "status", "created_at", "updated_at"],
  //     columnSortModel: [{ field: 'name', sort: 'asc' }]
  //   });

  static LEADS = (dealerId: string, group_id: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/leads`,
        queryParams: {
          dealer: dealerId,
          group_entity_filter: JSON.stringify({
            group_id,
          })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: false,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 800,
      exportFileName: `${dealerId}`,
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: true,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON },
        { field: 'lead_details_in_a_string', renderCell: RenderCellTypes.TEXT_WITH_COPY },
        { field: 'latest_lead_active_date', renderCell: RenderCellTypes.DATE },
      ],
      visibleColumns: ["lead_details_in_a_string", "segment", "engagement_index", "total_messages_sent", "latest_lead_active_date", "nurturing_status", "dealership_location", "middle_name", "address", "city", "state", "zip", "phone", "phone1", "phone2", "unsubscribes", "lead_status", "lead_type", "source", "sales_person", "voi_year", "voi_make", "voi_model", "voi_stock", "voi_vin", "voi_status", "voi_trim", "voi_price", "first_lead_creation_date", "unique_crm_lead_id", "unique_crm_customer_id"],
      filterableFields: [
        "lead_details_in_a_string",
        "segment",
        "engagement_index",
        "nurturing_status",
        "lead_status",
        "lead_type",
        "source",
        "sales_person",
        "voi_status"
      ],
    });
  static SEGMENTS = (dealerId: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/segments`,
        queryParams: { dealer: dealerId },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: false,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 800,
      exportFileName: "segments-export",
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: true,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON_WITH_ICON },
        { field: 'no_of_leads', renderCell: RenderCellTypes.COUNT_WITH_ICON },
        { field: 'LEAD_CONTACTED', renderCell: RenderCellTypes.NUMBER },
        { field: 'status', renderCell: RenderCellTypes.STATUS },
        { field: 'last_added_date', renderCell: RenderCellTypes.DATE },
        { field: 'created_at', renderCell: RenderCellTypes.DATE },
        { field: 'updated_at', renderCell: RenderCellTypes.DATE },
      ],
      visibleColumns: ["name", "no_of_leads", "LEAD_CONTACTED", "status", "last_added_date", "leads_in_nurturing", "created_at", "updated_at"],
      filterableFields: ["name", "no_of_leads", "LEAD_CONTACTED", "status", "last_added_date", "leads_in_nurturing", "created_at", "updated_at"],
    });

  static SALES_DEMO = (renderData: any, mySqlFlag: Boolean, filterType: string, timeperiod: string | number, start_date: string, end_date: string) => {
    let endpoint = `${DataGridTypes.API_VERSION_2}`;
    if (
      filterType === metricTypeEnum.opportunityAddedInNurturing ||
      filterType === metricTypeEnum.leadContacted ||
      filterType === metricTypeEnum.leadSold
    ) {
      endpoint += '/leads';
    } else {
      endpoint += '/segments';
    }

    let queryParams = {};
    if (timeperiod === 'CUSTOM_RANGE') {
      queryParams = {
        group_entity_filter: JSON.stringify(renderData.data?.group_entity_filter) || {},
        dealer: renderData.dealershipId,
        mysql: mySqlFlag,
        lead_filter: JSON.stringify(renderData.data?.lead_filter),
        startDate: start_date,
        endDate: end_date,
      };
    } else {
      queryParams = {
        group_entity_filter: JSON.stringify(renderData.data?.group_entity_filter) || {},
        dealer: renderData.dealershipId,
        mysql: mySqlFlag,
        lead_filter: JSON.stringify(renderData.data?.lead_filter),
        timeperiod: timeperiod,
      };
    }
    const now = new Date();
    const formattedDate = `${now.getFullYear()}${(now.getMonth() + 1)
      .toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours()
        .toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds()
          .toString().padStart(2, '0')}`;

    return new DataGridTypes({
      apiDetails: { endpoint, queryParams },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 700,
      exportFileName: `${filterType}_${timeperiod}_${formattedDate}`.toLowerCase(),
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON },
        { field: 'first_name', renderCell: RenderCellTypes.BUTTON },
        { field: 'no_of_leads', renderCell: RenderCellTypes.COUNT_WITH_ICON },
        { field: 'LEAD_CONTACTED', renderCell: RenderCellTypes.COUNT_WITH_ICON },
        { field: 'LEAD_SOLD', renderCell: RenderCellTypes.COUNT_WITH_ICON },
        { field: 'lead_created_date_crm', renderCell: RenderCellTypes.DATE },
        { field: 'first_lead_creation_date', renderCell: RenderCellTypes.DATE },
        { field: 'latest_lead_active_date', renderCell: RenderCellTypes.DATE },
        { field: 'enrolled_date', renderCell: RenderCellTypes.DATE },
        { field: 'latest_contacted_date', renderCell: RenderCellTypes.DATE },
        { field: 'date_sold', renderCell: RenderCellTypes.DATE },
        { field: 'nurturing_status', renderCell: RenderCellTypes.STATUS },
        { field: 'conversion_rate_raw', renderCell: RenderCellTypes.RATE },
      ],
      filterableFields: [
        'name',
        'Altoona, PA',
        'Email',
        'Address1',
        'City',
        'State',
        'Zip',
        'Cell Phone',
        'Home Phone',
        'Work Phone',
        'DoNotEmail',
        'Status',
        'lead_type',
        'Source Description',
        'SalesRepName',
        'Wanted Veh Year',
        'Wanted Veh Make',
        'Wanted Veh Model',
        'Vehicle 1 Stock Number',
        'Vehicle 1 Vin',
        'New/Used',
        'Wanted Veh Trim',
        'Wanted Veh Price',
        'Date In',
        'Date Ir',
        'unique_crm_lead_id',
        'unique_crm_customer_id',
        'segment',
        'engagement_index',
        'total_messages_sent',
        'first_name',
        'Email_mailshake',
        'Enrolled Date',
        'Date Contacted',
        'Lead-to',
        'Sold Y/N',
        'Days in Nurturin',
        '# Nurturing M',
        'Enrolled Status',
        'Enrolled Source',
        'Enrolled VOI',
        'Sold Source',
        'Vehicle Bought',
        'Sales Person',
        'status',
        'no_of_leads',
        'LEAD_CONTACTED',
        'LEAD_SOLD',
        'conversion_rate_raw',
        'lead_created_date_crm',
        "enrolled_date",
        "date_sold",
        'lead_to_sale_days',
        'days_in_nurturing',
        'number_of_nurturing_messages',
        'vehicle_bought',
        'sold_vin',
        'sold_source',
        'sales_person',
        'enrolled_lead_status',
        'enrolled_source',
        'enrolled_voi',
        'latest_contacted_date',
        'latest_lead_active_date',
        'lead_to_contacted_days',
        'dealership_location',
        'sold_yn',
        'email',
        'first_lead_creation_date',
        'address',
      ],
    });
  }

  static UNSOLD = (dealerId: string, timeperiod: string = 'LAST_MONTH', mySqlFlag: boolean = true) => {
    const endpoint = `${DataGridTypes.API_VERSION_2}/leads/unsold`;
    const queryParams = {
      dealer_id: dealerId,
      timeperiod: timeperiod,
      mysql: mySqlFlag,
    };

    const now = new Date();
    const formattedDate = `${now.getFullYear()}${(now.getMonth() + 1)
      .toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours()
        .toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds()
          .toString().padStart(2, '0')}`;

    return new DataGridTypes({
      apiDetails: { endpoint, queryParams },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 700,
      exportFileName: `unsold_${timeperiod}_${formattedDate}`.toLowerCase(),
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'name', renderCell: RenderCellTypes.BUTTON },
        { field: 'lead_created_date', renderCell: RenderCellTypes.DATE },
        { field: 'date_sold', renderCell: RenderCellTypes.DATE },
        { field: 'status', renderCell: RenderCellTypes.STATUS },
        { field: 'conversion_rate_raw', renderCell: RenderCellTypes.RATE },
      ],
      filterableFields: [
        'name',
        'email',
        'status',
        'source',
        'voi_name',
        'lead_intelligence',
        'suggested_strategy',
        'lead_created_date',
      ],
    });
  }

  static SCOPES = () =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/scopes`,
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: 'scopes-export',
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: false,
      multiSelectable: false,
      renderCellMapping: [
        {
          field: 'name',
          renderCell: RenderCellTypes.BUTTON,
        },
        {
          field: 'status',
          renderCell: RenderCellTypes.STATUS,
        },
      ],
      visibleColumns: ['name', 'description', 'scope', 'status', 'created_at', 'updated_at'],
      filterableFields: ['name', 'description', 'scope', 'status', 'created_at', 'updated_at'],
    });

  static RESOURCES = () =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/resources`,
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: 'resources-export',
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: false,
      multiSelectable: false,
      renderCellMapping: [
        {
          field: 'name',
          renderCell: RenderCellTypes.BUTTON,
        },
        {
          field: 'status',
          renderCell: RenderCellTypes.STATUS,
        },
      ],
      visibleColumns: ['name', 'path', 'component', 'status', 'created_at', 'updated_at'],
      filterableFields: ['name', 'path', 'component', 'status', 'created_at', 'updated_at'],
    });

  static RUN_LOGS = (dealerId: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/run-v2`,
        queryParams: { dealer: dealerId },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 600,
      exportFileName: 'run-logs-export',
      columnResizable: true,
      isRowSelectable: false,
      isOpportunity: false,
      multiSelectable: false,
      renderCellMapping: [
        { field: '_id', renderCell: RenderCellTypes.BUTTON },
        { field: 'name', renderCell: RenderCellTypes.TEXT },
        { field: 'run_type', renderCell: RenderCellTypes.TEXT },
        { field: 'run_by', renderCell: RenderCellTypes.TEXT },
        { field: 'run_by_id', renderCell: RenderCellTypes.TEXT },
        { field: 'created_at', renderCell: RenderCellTypes.DATE },
        { field: 'action_count', renderCell: RenderCellTypes.NUMBER },
        { field: 'status', renderCell: RenderCellTypes.STATUS },
      ],
      columnSortModel: [
        { field: '_id', sort: 'desc' },
      ],
      visibleColumns: [
        '_id',
        'name',
        'run_type',
        "run_by",
        "run_by_id",
        'created_at',
        'action_count',
        'status',
      ],
      filterableFields: ['name', 'run_type', 'run_by', 'run_by_id', 'created_at', 'action_count', 'status'],
    });

  static LEASE_OFFERS = (dealerId?: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/offer`,
        queryParams: {
          offer_type: 'LEASE',
          ...(dealerId && dealerId !== 'default' && { dealer: dealerId })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 400,
      exportFileName: 'lease_offers_export',
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'headline', renderCell: RenderCellTypes.BUTTON },
        { field: 'offer_image_url', renderCell: RenderCellTypes.IMAGE },
        { field: 'end_date', renderCell: RenderCellTypes.DATE },
        { field: 'actions', renderCell: RenderCellTypes.ACTION_BUTTONS },
      ],
      visibleColumns: ['headline', 'vehicle_model', 'offer_image_url', 'end_date', 'actions'],
      filterableFields: ['headline', 'vehicle_model', 'offer_image_url', 'end_date'],
    });

  static LEASE_FINANCE_OFFERS = (dealerId?: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/offer`,
        queryParams: {
          offer_type: 'LEASE_FINANCE',
          ...(dealerId && dealerId !== 'default' && { dealer: dealerId })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 400,
      exportFileName: 'lease_finance_offers_export',
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'headline', renderCell: RenderCellTypes.BUTTON },
        { field: 'offer_image_url', renderCell: RenderCellTypes.IMAGE },
        { field: 'end_date', renderCell: RenderCellTypes.DATE },
        { field: 'actions', renderCell: RenderCellTypes.ACTION_BUTTONS },
      ],
      visibleColumns: ['headline', 'vehicle_model', 'offer_image_url', 'end_date', 'actions'],
      filterableFields: ['headline', 'vehicle_model', 'offer_image_url', 'end_date'],
    });

  static FINANCE_OFFERS = (dealerId?: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/offer`,
        queryParams: {
          offer_type: 'FINANCE',
          ...(dealerId && dealerId !== 'default' && { dealer: dealerId })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 400,
      exportFileName: 'finance_offers_export',
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: true,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'headline', renderCell: RenderCellTypes.BUTTON },
        { field: 'offer_image_url', renderCell: RenderCellTypes.IMAGE },
        { field: 'end_date', renderCell: RenderCellTypes.DATE },
        { field: 'actions', renderCell: RenderCellTypes.ACTION_BUTTONS },
      ],
      visibleColumns: ['headline', 'vehicle_model', 'offer_image_url', 'end_date', 'actions'],
      filterableFields: ['headline', 'vehicle_model', 'offer_image_url', 'end_date'],
    });

  static VALUE_CONTENT = (dealerId?: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/dealer-value`,
        queryParams: {
          ...(dealerId && dealerId !== 'default' && { dealer: dealerId })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: 'value_content_export',
      columnResizable: true,
      isRowSelectable: true,
      isOpportunity: false,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'headline', renderCell: RenderCellTypes.BUTTON },
        { field: 'value_type', renderCell: RenderCellTypes.STATUS },
        { field: 'end_date', renderCell: RenderCellTypes.DATE },
        { field: 'actions', renderCell: RenderCellTypes.ACTION_BUTTONS },
      ],
      visibleColumns: ['headline', 'value_type', 'end_date', 'actions'],
      filterableFields: ['headline', 'value_type', 'end_date'],
    });

  static FOOTER_IMAGE = (dealerId?: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/footer-image`,
        queryParams: {
          ...(dealerId && dealerId !== 'default' && { dealer: dealerId })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: 'footer_image_export',
      columnResizable: true,
      isRowSelectable: false,
      isOpportunity: false,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'image_description', renderCell: RenderCellTypes.BUTTON },
        { field: 'image_address', renderCell: RenderCellTypes.TEXT },
        { field: 'image_url', renderCell: RenderCellTypes.TEXT },
        { field: 'expiry_date', renderCell: RenderCellTypes.DATE },
        { field: 'actions', renderCell: RenderCellTypes.ACTION_BUTTONS },
      ],
      visibleColumns: ['image_description', 'image_url', 'expiry_date', 'actions'],
    });

  static DEALER_SPECIALS = (dealerId?: string) =>
    new DataGridTypes({
      apiDetails: {
        endpoint: `${DataGridTypes.API_VERSION_2}/dealer-special`,
        queryParams: {
          ...(dealerId && dealerId !== 'default' && { dealer: dealerId })
        },
      },
      pageSize: 20,
      pageMode: PageMode.Scroll,
      filterable: true,
      renderMode: RenderMode.Server,
      editable: false,
      exportable: true,
      gridHeight: 500,
      exportFileName: 'dealer_specials_export',
      columnResizable: true,
      isRowSelectable: false,
      isOpportunity: false,
      multiSelectable: false,
      renderCellMapping: [
        { field: 'special_headline', renderCell: RenderCellTypes.BUTTON },
        { field: 'special_description', renderCell: RenderCellTypes.TEXT },
        { field: 'start_date', renderCell: RenderCellTypes.DATE },
        { field: 'end_date', renderCell: RenderCellTypes.DATE },
        { field: 'applicable_model', renderCell: RenderCellTypes.CHIP_ARRAY },
        { field: 'disclaimer_text', renderCell: RenderCellTypes.TEXT },
        { field: 'actions', renderCell: RenderCellTypes.ACTION_BUTTONS },
      ],
      visibleColumns: ['special_headline', 'end_date', 'applicable_model', 'actions'],
      filterableFields: ['special_headline', 'end_date', 'applicable_model'],
    });
}

export default DataGridTypes;
